export function addToImportMap(resources: Record<string, string>) {
  const existingImportMap = document.querySelector<HTMLScriptElement>(
    'script[type=importmap]',
  )
  const importMap = existingImportMap ?? document.createElement('script')
  importMap.type = 'importmap'
  importMap.textContent = JSON.stringify({
    imports: {
      ...(importMap.textContent
        ? JSON.parse(importMap.textContent).imports
        : {}),
      ...resources,
    },
  })
  if (!existingImportMap) {
    document.head.append(importMap)
  }
}

export function esmSh(resource: string, version: string, dev = false) {
  const [root, ...segments] = resource.split('/')
  const resourceUrl = new URL(`https://esm.sh/${root}@${version}`)
  if (segments.length > 0) {
    resourceUrl.pathname += '/' + segments.join('/')
  }
  if (dev) {
    resourceUrl.search = 'dev'
  }
  return resourceUrl.toString()
}
